export default "__VITE_ASSET__d0616abe__"